module.exports = __webpack_public_path__ + "media/flags/si-462284eb.svg";